module.exports = __webpack_public_path__ + "img/android.e3ea015c.svg";